export const handleCopyAddressClick = (address: string, onFinished?: () => void) => {
  navigator.clipboard.writeText(address);
};

export const handleOpenInAppleMapsClick = (query: string, onFinished?: () => void) => {
  const url = `https://maps.apple.com/?q=${encodeURIComponent(query)}`;
  window.open(url, '_blank');
};

export const handleOpenInGoogleMapsClick = (query: string, onFinished?: () => void) => {
  const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
  window.open(url, '_blank');
};
